import { render } from "./AssignmentCard.vue?vue&type=template&id=a4e171ee&scoped=true"
import script from "./AssignmentCard.vue?vue&type=script&lang=js"
export * from "./AssignmentCard.vue?vue&type=script&lang=js"

import "./AssignmentCard.vue?vue&type=style&index=0&id=a4e171ee&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./AssignmentCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e171ee"]])

export default __exports__